// Types
import { EnvelopeIconType } from '@atoms/index';

/**
 * Enum representing the status values for the forgot password flow.
 */
export enum ForgotPasswordStatus {
  /**
   * Initial status.
   */
  INITIAL = 'INITIAL',
  /**
   * Status indicating that the email has been sent.
   */
  EMAIL_SENT = 'EMAIL_SENT',
  /**
   * Status indicating a forced retry.
   */
  FORCED_RETRY = 'FORCED_RETRY',
}

/**
 * Represents the state machine for the ForgotPasswordState.
 */
type ForgotPasswordElements = {
  /**
   * The title associated with the forgot password state.
   */
  title: string;
  /**
   * The message associated with the forgot password state.
   * @param {string} username - The username to display in the messages.
   * @returns {string} - Message for the user.
   */
  message: (username?: string) => string;
  /**
   * The confirmation message associated with the forgot password state.
   */
  confirmation: string;
  /**
   * The envelope type associated with the forgot password state.
   */
  envelopeType: EnvelopeIconType;
};

/**
 * Type representing the elements of the forgot password state.
 */
export type ForgotPasswordStateMachine = Record<ForgotPasswordStatus, ForgotPasswordElements>;
